import { FormattedMessage, injectIntl } from "react-intl";
import {
  ActionBar,
  Details,
  DetailsHeaderItem,
  DetailsItem,
  DetailsPicture,
  Picture,
} from "lcm-iot-commons";
import { assetShape } from "../../shapes/assetsShape";

type OwnProps = {
  asset?: assetShape;
};

const defaultProps: Partial<OwnProps> = {
  asset: undefined,
};

type Props = OwnProps & typeof defaultProps;

export function AssetDetailsItem({ asset }: Props) {
  return asset ? (
    <div className="asset-detail-item">
      <ActionBar>
        <h2>
          <FormattedMessage id="label.asset" />
        </h2>
      </ActionBar>
      <Details>
        <DetailsPicture>
          <Picture
            src={(asset as $TSFixMe).productPictureUrl}
            alt={(asset as $TSFixMe).serialNumber}
            placeholder="icon-eh-device"
          />
        </DetailsPicture>
        <DetailsHeaderItem
          id="asset-serialnumber"
          translationKey="label.serial_number"
          value={(asset as $TSFixMe).serialNumber}
          breakValue
        />
        <DetailsItem
          id="asset-manufacturer"
          translationKey="label.manufacturer"
          value={(asset as $TSFixMe).manufacturerName}
        />
      </Details>
    </div>
  ) : null;
}

AssetDetailsItem.defaultProps = defaultProps;

// @ts-expect-error TS(2769) FIXME: No overload matches this call.
export default injectIntl(AssetDetailsItem);
